import { DependencyList, useEffect, useRef } from 'react';

const useAutoFetch = (
  fetchFn: () => void,
  dependencies: DependencyList,
  skipFirstRender: boolean = true,
) => {
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;

      if (!skipFirstRender) {
        fetchFn();
      }

      return;
    }

    fetchFn();
  }, dependencies);
};

export default useAutoFetch;
